import { createFileRoute } from '@tanstack/react-router';

import { organizationsApi } from '@/features/organisations/api/organisation-api';
import { OrganisationSettings } from '@/features/organisations/components/organisation-settings';
import { ensureQueryData } from '@/utils/ensure-query-data';

export const Route = createFileRoute('/_authenticated/$tenantId/settings/')({
  loader: async ({ context: { queryClient }, params }) => {
    const { tenantId } = params;

    return ensureQueryData(
      queryClient,
      organizationsApi.getOrganisation(tenantId),
    );
  },
  component: OrganisationSettings,
});
